
import { Link } from "@mui/material";
import get from "lodash/get";
import { TextFieldProps, TextField, useRecordContext } from "react-admin";

interface Props extends TextFieldProps {
    type: string
}

export const MessageField = (props: Props) => {
    const { type, source, className, sx } = props;
    const record = useRecordContext(props);
    if (record && source) {
        const value = get(record, source);
        const typeVal = get(record, type);
        switch (typeVal) {
            case "img": return (
                <Link href={value} target="_blank" className={className} sx={sx}><img src={value}
                    style={{ height: "3rem", maxWidth: "16rem", objectFit: "contain" }} />
                </Link>
            )
            case "text": return <TextField source={source} record={record} className={className} sx={sx} />
            case "creds": return <TextField source={source} record={record} className={className} sx={sx} />
        }
    }
    return null;
}